import { render } from "./ItemStock.vue?vue&type=template&id=749420ef&scoped=true"
import script from "./ItemStock.vue?vue&type=script&lang=js"
export * from "./ItemStock.vue?vue&type=script&lang=js"

import "./ItemStock.vue?vue&type=style&index=0&id=749420ef&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-749420ef"]])

export default __exports__